import "./assets/css/index.css";

import { Provider } from "react-redux";
import { store } from "./store";

import { BrowserRouter, Route, Routes } from "react-router-dom";
import FloatingCart from "./components/FloatingCart";

import AllAppRoutes from "./common/routes";

import Homepage from "./page/home";
import Marketplace from "./page/marketplace";
import CategoriesPage from "./page/category";
import CartPage from "./page/cart";
import ProductDetailPage from "./page/detail";
import WelcomePage from "./page/welcome";
import SignInPage from "./page/auth/signin";
import SignUpPage from "./page/auth/signup";
import ProfileSettings from "./page/profile/settings/settings";
import Wise9jaPage from "./page/wise9ja";
import HistoryPage from "./page/profile/history";
import DiscoverPage from "./page/discover";
import NotificationsPage from "./page/profile/notifications";
import OrdersPage from "./page/profile/orders";
import WalletPage from "./page/wallet";
import FourwardPage from "./page/fourward";
import GroupAccountPage from "./page/group-account";
import FundWalletPage from "./page/profile/actions/fund-wallet";
import ActionStatusPage from "./page/profile/actions/action-status";
import StartEarningPage from "./page/profile/actions/wise";
import Wise9jaHistoryPage from "./page/profile/history/wise9ja-history";
import WalletHistoryPage from "./page/profile/history/wallet-history";
import SingleHistoryPage from "./page/profile/actions/single-history";
import ContactUsPage from "./page/contact";
import PartnerPage from "./page/partner";
import TermsPage from "./page/terms";
import PrivacyPage from "./page/privacy";
import HowWise9jaWorks from "./page/wise9ja-how";
import VerificationPage from "./page/auth/verification";
import VerifySmsLinkPage from "./page/VerifySmsLinkPage";
import RedeemBonusCodePage from "./page/RedeemBonusCodePage";
import SalesReportPage from "./page/sales-report";
import HowReferralWorksPage from "./page/referral_how";
import ReferralPage from "./page/profile/settings/referral";
import EIdPage from "./page/profile/settings/e-id";
import AssessmentPage from "./page/profile/assessment";
import HistoryDetailPage from "./page/profile/history-detail";
import SendResetMail from "./page/auth/reset";
import VerifyPasswordResetOtp from "./page/auth/verify_reset_mail";
import ResetPasswordPage from "./page/auth/reset_password";
import TransferToFriend from "./page/profile/actions/friend";
import TransferBetweenAccounts from "./page/profile/actions/transfer";
import WithdrawToBank from "./page/profile/actions//bank";

import ProfileBasicSettings from "./page/profile/settings/update/basic-settings";
import SecuritySettings from "./page/profile/settings/security-settings.jsx";
import UpdatePasswordPage from "./page/profile/settings/update/password";
import UpdateTransactionCode from "./page/profile/settings/update/trans_code";
import UpdateLoginPin from "./page/profile/settings/update/login_pin";
import CheckOutPage from "./page/checkout";
import PayBills from "./page/profile/actions/bills";
import SignupSuccessfulPage from "./page/auth/signupsuccessful";
import CompleteKYCPage from "./page/auth/kyc";
import UpdateProfilePic from "./page/profile/settings/update/pic";
import Shop from "./page/shop";
import Restaurant from "./page/restaurant/restaurant";
import RawFood from "./page/raw-food/RawFood";
import Store from "./page/store/Store";
import BusinessDetailPage from "./components/BusinessDetailPage";
import ReviewCheckout from "./page/restaurant/ReviewCheckout";
import CheckoutSuccessful from "./page/restaurant/CheckoutSuccessful";
import TrackOrder from "./page/restaurant/TrackOrder";
import JoinUsPage from "./page/profile/settings/join";
import JoinAsBiker from "./page/profile/settings/JoinAsBiker";
import JoinAsAmbassador from "./page/profile/settings/JoinAsAmbassador";
import AmbassadorLessonsPage from "./page/profile/settings/AmbassadorLessonsPage";
import JoinAsFacilitator from "./page/profile/settings/JoinAsFacilitator";
import UpdateTransPin from "./page/profile/settings/update/trans_code_two";
import RestaurantCartPage from "./page/restaurant/RestaurantCartPage";
import ResetPin from "./page/auth/reset_pin";
import UpdateEmailPage from "./page/profile/settings/update/email";
import OrderHistory from "./page/profile/settings/view-orders";
import Profile from "./page/Profile";
import BVNVerification from "./page/profile/BVNVerification";
import { Toaster } from "react-hot-toast";
import RestaurantDashboard from "./page/restaurant-dashboard/Dashboard";
import RestaurantTransactions from "./page/restaurant-dashboard/Transactions";
import RestaurantDelivery from "./page/restaurant-dashboard/MyDelivery";
import RestaurantMenu from "./page/restaurant-dashboard/Menu";
import RestaurantProfile from "./page/restaurant-dashboard/Profile";
import DeliveryPage from "./page/delivery/Delivery";
import SupportHome from "./page/support/SupportHome";
import InterventionPage from "./page/support/InterventionPage";
import DriverInterventionPage from "./page/support/DriverInterventionPage";
import SupportBusinessesPage from "./page/support/SupportBusinessesPage";
import SupportProfilePage from "./page/support/SupportProfilePage";
import AdminHome from "./page/admin/AdminHome";
import AdminProgress from "./page/admin/AdminProgress";
import AdminInterventions from "./page/admin/AdminInterventions";
import AdminDriverInterventions from "./page/admin/AdminDriverInterventions";
import AdminApprovals from "./page/admin/AdminApprovals";
import AdminAmbassadorsPage from "./page/admin/AdminAmbassadorsPage";
import AdminSales from "./page/admin/AdminSales";
import AdminBusiness from "./page/admin/components/AdminBusiness";
import AdminRateSettings from "./page/admin/AdminRateSettings";
import AdminNotifications from "./page/admin/AdminNotifications";
import AdminBroadcast from "./page/admin/AdminBroadcast";
import AdminCampaign from "./page/admin/AdminCampaign";
import AdminFaqPage from "./page/admin/AdminFaqPage";
import DeliveryHome from "./page/biker/DeliveryHome";
import BikerTransactionsPage from "./page/biker/BikerTransactionsPage";
import DeliveryProfilePage from "./page/biker/DeliveryProfilePage";
import FullscreenMapPage from "./page/biker/FullscreenMapPage";
import BecomeBusinessPage from "./page/restaurant-dashboard/BecomeBusinessPage";
import SupportOfficerHome from "./page/support-officer/SupportOfficerHome";
import SupportOfficerProgress from "./page/support-officer/SupportOfficerProgress";
import SupportOfficerSales from "./page/support-officer/SupportOfficerSales";
import SupportOfficerBusinessPage from "./page/support-officer/SupportOfficerBusinessPage";
import SupportExecutiveHomeWrapper from "./page/support-executive/SupportExecutiveHomeWrapper";
import SupportExecutiveIntervention from "./page/support-executive/SupportExecutiveIntervention";
import SupportExecutiveDriverIntervention from "./page/support-executive/SupportExecutiveDriverIntervention";
// import SupportExecutiveSales from "./page/support-executive/SupportExecutiveSales";
import SupportManagerHome from "./page/support-manager/SupportManagerHome";
import SupportManagerSales from "./page/support-manager/SupportManagerSales";
import SupportManagerBusiness from "./page/support-manager/SupportManagerBusiness";
import SupportManagerProgress from "./page/support-manager/SupportManagerProgress";
import SupportExecutiveProgressWrapper from "./page/support-executive/SupportExecutiveProgressWrapper";
import SupportExecutiveSalesWrapper from "./page/support-executive/SupportExecutiveSalesWrapper";
import SupportExecutiveBusinessWrapper from "./page/support-executive/SupportExecutiveBusinessWrapper";
import GlobalImpersonationBanner from "./components/GlobalImpersonationBanner";
import DragToScroll from "./components/DragToScroll";

// Imported last so the desktop/tablet responsive rules win over base layout CSS.
import "./assets/css/responsive.css";

const AppRoutes = () => {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <FloatingCart />
        <GlobalImpersonationBanner />
        <DragToScroll />
        <Toaster />
        <div className="app-shell">
        <Routes>
          <Route path="/" element={<WelcomePage />} />
          <Route path="/welcome" element={<WelcomePage />} />
          <Route path="/signin" element={<SignInPage />} />
          <Route path="/signup" element={<SignUpPage />} />
          <Route path="/sms-verification" element={<RedeemBonusCodePage />} />
          <Route path="/verify-sms-link" element={<VerifySmsLinkPage />} />
          <Route path="/v/:token" element={<VerifySmsLinkPage />} />
          <Route path="/code" element={<RedeemBonusCodePage />} />
          <Route path="/code/:code" element={<RedeemBonusCodePage />} />
          <Route
            path={AllAppRoutes.successful_signup}
            element={<SignupSuccessfulPage />}
          />
          <Route path="/reset-mail" element={<SendResetMail />} />
          <Route path="/reset-pin" element={<ResetPin />} />
          <Route
            path={AllAppRoutes.complete_kyc}
            element={<CompleteKYCPage />}
          />
          <Route path="/verify-passcode" element={<VerifyPasswordResetOtp />} />
          <Route
            path="/reset-password/:id/:token"
            element={<ResetPasswordPage />}
          />

          <Route
            path={AllAppRoutes.verify_email}
            element={<VerificationPage />}
          />
          <Route
            path={AllAppRoutes.how_wise9ja_works}
            element={<HowWise9jaWorks />}
          />
          {/* <Route path={AllAppRoutes.contact} element={<ContactUsPage />} /> */}
          <Route path={AllAppRoutes.partner} element={<PartnerPage />} />
          <Route path={AllAppRoutes.terms} element={<TermsPage />} />
          <Route path={AllAppRoutes.privacy} element={<PrivacyPage />} />
          <Route path={AllAppRoutes.pay_bills} element={<PayBills />} />
          <Route path="/home" element={<Homepage />} />
          <Route path="/fourward" element={<FourwardPage />} />
          <Route path="/group-account" element={<GroupAccountPage />} />
          <Route path="/marketplace" element={<Marketplace />} />
          <Route path="/history" element={<HistoryPage />} />
          {/* <Route path="/history" element={<HistoryPage />} /> */}

          <Route path="/notifications" element={<NotificationsPage />} />
          <Route path="/wise9ja" element={<Wise9jaPage />} />
          <Route path="/discover" element={<DiscoverPage />} />
          <Route path="/categories" element={<CategoriesPage />} />
          <Route path="/cart" element={<CartPage />} />
          <Route path="/detail" element={<ProductDetailPage />} />

          <Route path={"/order-history"} element={<OrderHistory />} />
          <Route
            path={"/restaurant/transactions"}
            element={<RestaurantTransactions />}
          />
          <Route path="/orders" element={<OrdersPage />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/restaurant" element={<Restaurant />} />
          <Route path="/raw_food" element={<RawFood />} />
          <Route path="/store" element={<Store />} />
          <Route
            path="/restaurant/:id"
            exact
            element={<BusinessDetailPage businessType="restaurant" />}
          />
          <Route
            path="/restaurant/:id/cart"
            exact
            element={<RestaurantCartPage businessType="restaurant" />}
          />
          <Route
            path="/restaurant/:id/checkout"
            exact
            element={<ReviewCheckout businessType="restaurant" />}
          />
          <Route
            path="/restaurant/:id/checkout_successful"
            exact
            element={<CheckoutSuccessful />}
          />
          <Route
            path="/restaurant/:id/track_order"
            exact
            element={<TrackOrder />}
          />
          <Route
            path="/raw_food/:id"
            exact
            element={<BusinessDetailPage businessType="raw_food" />}
          />
          <Route
            path="/raw_food/:id/cart"
            exact
            element={<RestaurantCartPage businessType="raw_food" />}
          />
          <Route
            path="/raw_food/:id/checkout"
            exact
            element={<ReviewCheckout businessType="raw_food" />}
          />
          <Route
            path="/raw_food/:id/checkout_successful"
            exact
            element={<CheckoutSuccessful />}
          />
          <Route
            path="/raw_food/:id/track_order"
            exact
            element={<TrackOrder />}
          />
          <Route
            path="/store/:id"
            exact
            element={<BusinessDetailPage businessType="store" />}
          />
          <Route
            path="/store/:id/cart"
            exact
            element={<RestaurantCartPage businessType="store" />}
          />
          <Route
            path="/store/:id/checkout"
            exact
            element={<ReviewCheckout businessType="store" />}
          />
          <Route
            path="/store/:id/checkout_successful"
            exact
            element={<CheckoutSuccessful />}
          />
          <Route path="/store/:id/track_order" exact element={<TrackOrder />} />
          <Route path="/join-us" element={<JoinUsPage />} />
          <Route path="/join-as-biker" element={<JoinAsBiker />} />
          <Route path={AllAppRoutes.become_ambassador} element={<JoinAsAmbassador />} />
          <Route path={AllAppRoutes.ambassador_lessons} element={<AmbassadorLessonsPage />} />
          <Route path={AllAppRoutes.become_facilitator} element={<JoinAsFacilitator />} />

          <Route path="/settings" element={<ProfileSettings />} />
          <Route
            path={AllAppRoutes.action_status_page}
            element={<ActionStatusPage />}
          />

          <Route
            path={AllAppRoutes.basic_profile}
            element={<ProfileBasicSettings />}
          />
          <Route
            path={AllAppRoutes.update_picture}
            element={<UpdateProfilePic />}
          />
          <Route
            path={AllAppRoutes.update_password}
            element={<UpdatePasswordPage />}
          />
          <Route
            path={AllAppRoutes.update_email}
            element={<UpdateEmailPage />}
          />
          <Route
            path={AllAppRoutes.update_transaction_code}
            element={<UpdateTransactionCode />}
          />
          <Route
            path={AllAppRoutes.update_trans_pin}
            element={<UpdateTransPin />}
          />
          <Route
            path={AllAppRoutes.update_login_pin}
            element={<UpdateLoginPin />}
          />
          {/* <Route path={AllAppRoutes.view_order_history} element={<OrderHistory />} /> */}

          {/* 2. ADD THE ROUTE FOR THE SECURITY SETTINGS PAGE */}
          <Route
            path="/profile/security-settings"
            element={<SecuritySettings />}
          />
          <Route
            path={AllAppRoutes.restaurant_dashboard}
            element={<RestaurantDashboard />}
          />
          <Route
            path={AllAppRoutes.restaurant_delivery}
            element={<RestaurantDelivery />}
          />
          <Route
            path={AllAppRoutes.restaurant_menu}
            element={<RestaurantMenu />}
          />
          <Route
            path={AllAppRoutes.restaurant_profile}
            element={<RestaurantProfile />}
          />
          <Route
            path={AllAppRoutes.restaurant_dashboard}
            element={<Profile />}
          />
          <Route
            path={AllAppRoutes.restaurant_support}
            element={<ContactUsPage />}
          />

          <Route path="/history-detail/:id" element={<HistoryDetailPage />} />
          <Route path="/profile/settings" element={<ProfileBasicSettings />} />

          <Route
            path={AllAppRoutes.transfer_to_friend}
            element={<TransferToFriend />}
          />
          <Route
            path={AllAppRoutes.transfer_between_accounts}
            element={<TransferBetweenAccounts />}
          />
          <Route
            path={AllAppRoutes.withdraw_to_bank}
            element={<WithdrawToBank />}
          />

          <Route path="/profile/sales-report" element={<SalesReportPage />} />
          <Route path={AllAppRoutes.e_id} element={<EIdPage />} />
          <Route path={AllAppRoutes.assessment} element={<AssessmentPage />} />
          <Route
            path="/profile/bvn-verification"
            element={<BVNVerification />}
          />

          <Route
            path={AllAppRoutes.fund_user_wallet}
            element={<FundWalletPage />}
          />
          <Route
            path={AllAppRoutes.start_earning}
            element={<StartEarningPage />}
          />
          <Route
            path={AllAppRoutes.wise9ja_history}
            element={<Wise9jaHistoryPage />}
          />
          <Route
            path={AllAppRoutes.wallet_history}
            element={<WalletHistoryPage />}
          />
          <Route
            path={AllAppRoutes.single_history}
            element={<SingleHistoryPage />}
          />
          <Route
            path={AllAppRoutes.how_referral_works}
            element={<HowReferralWorksPage />}
          />
          <Route
            path={AllAppRoutes.become_business}
            element={<BecomeBusinessPage />}
          />
          <Route
            path={AllAppRoutes.profile_referral}
            element={<ReferralPage />}
          />
          {/* <Route path={AllAppRoutes.delivery} element={<DeliveryPage />} /> */}
          <Route path="/biker/dashboard" element={<DeliveryHome />} />
          <Route
            path="/biker/transactions"
            element={<BikerTransactionsPage />}
          />
          <Route path="/biker/profile" element={<DeliveryProfilePage />} />
          <Route
            path="/biker/map/:trackerLink"
            element={<FullscreenMapPage />}
          />
          <Route path="/support" element={<SupportHome />} />
          <Route path={AllAppRoutes.support} element={<SupportHome />} />
          <Route
            path="/support/intervention"
            element={<InterventionPage userRole="SO" />}
          />
          <Route
            path="/support/businesses"
            element={<SupportBusinessesPage />}
          />
          <Route path="/support/profile" element={<SupportProfilePage />} />

          <Route path="/admin/dashboard" element={<AdminHome />} />
          <Route path="/admin/progress" element={<AdminProgress />} />
          <Route path="/admin/interventions" element={<AdminInterventions />} />
          <Route
            path="/admin/driver-interventions"
            element={<AdminDriverInterventions />}
          />
          <Route path="/admin/approvals" element={<AdminApprovals />} />
          <Route path="/admin/ambassadors" element={<AdminAmbassadorsPage />} />
          <Route path="/admin/sales" element={<AdminSales />} />
          <Route path="/admin/business" element={<AdminBusiness />} />
          <Route
            path="/admin/support-managers"
            element={<SupportOfficerHome userRole="SM" />}
          />
          <Route path="/admin/rate-settings" element={<AdminRateSettings />} />
          <Route path="/admin/notifications" element={<AdminNotifications />} />
          <Route path="/admin/broadcast" element={<AdminBroadcast />} />
          <Route path="/admin/campaign" element={<AdminCampaign />} />
          <Route path="/admin/faqs" element={<AdminFaqPage />} />

          <Route
            path="/support-officer"
            element={<SupportOfficerHome userRole="SO" />}
          />
          <Route path="/support-manager" element={<SupportManagerHome />} />
          <Route
            path="/support-manager/progress"
            element={<SupportManagerProgress />}
          />
          <Route
            path="/support-manager/intervention"
            element={<InterventionPage userRole="SM" />}
          />
          <Route
            path="/support-manager/driver-intervention"
            element={<DriverInterventionPage userRole="SM" />}
          />
          <Route
            path="/support-manager/sales"
            element={<SupportManagerSales />}
          />
          <Route
            path="/support-manager/business"
            element={<SupportManagerBusiness />}
          />
          <Route
            path="/support-officer/progress"
            element={<SupportOfficerProgress />}
          />
          <Route
            path="/support-officer/sales"
            element={<SupportOfficerSales />}
          />
          <Route
            path="/support-officer/business"
            element={<SupportOfficerBusinessPage />}
          />
          <Route
            path="/support-officer/intervention"
            element={<InterventionPage userRole="SO" />}
          />
          <Route
            path="/support-officer/driver-intervention"
            element={<DriverInterventionPage userRole="SO" />}
          />

          <Route
            path="/support-executive"
            element={<SupportExecutiveHomeWrapper />}
          />
          <Route
            path="/support-executive/progress"
            element={<SupportExecutiveProgressWrapper />}
          />
          <Route
            path="/support-executive/intervention"
            element={<SupportExecutiveIntervention />}
          />
          <Route
            path="/support-executive/driver-intervention"
            element={<SupportExecutiveDriverIntervention />}
          />
          <Route
            path="/support-executive/sales"
            element={<SupportExecutiveSalesWrapper />}
          />
          <Route
            path="/support-executive/business"
            element={<SupportExecutiveBusinessWrapper />}
          />
          <Route
            path="/support-executive/approvals"
            element={<AdminApprovals />}
          />
          <Route
            path="/support-executive/ambassadors"
            element={<AdminAmbassadorsPage />}
          />

          <Route path={AllAppRoutes.wallet} element={<WalletPage />} />
          <Route path="/checkout" element={<CheckOutPage />} />
        </Routes>
        </div>
      </BrowserRouter>
    </Provider>
  );
};

export default AppRoutes;
